import type { TOC } from '@ember/component/template-only'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import ContentTile from 'teacher-ui-client/components/tiles/content'
import { UiButton } from 'teacher-ui-client/components/ui-button'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { ContentfulEdit } from 'teacher-ui-client/components/contentful/edit'
import { LessonResourcesTile } from 'teacher-ui-client/components/tiles/lesson/resources'
import type { LessonResource } from 'teacher-ui-client/components/tiles/lesson/resource/type'

interface Signature {
  Element: Element
  Args: {
    coverClass: string
    coverUrl?: string
    entryId: string
    title?: string
    lessonResources: LessonResource[]
    openPreview?: () => unknown
    subtitle?: string
  }
  Blocks: {
    default: []
  }
}

export const LessonPreviewTile: TOC<Signature> = <template>
  <ContentTile class="flex flex-col p-6" ...attributes>
    <ContentfulEdit class="ml-auto" @entryId={{@entryId}} />
    <div class="flex h-full flex-col space-y-3 space-y-reverse">
      {{#if @coverUrl}}
        <img src={{@coverUrl}} alt={{@subtitle}} class="mx-auto {{@coverClass}}" />
      {{else}}
        <div class="{{@coverClass}}"></div>
      {{/if}}

      {{#if @title}}
        <h4 class="mx-2 h-14 text-center">{{@title}}</h4>
      {{/if}}

      {{#if @subtitle}}
        <p class="text-center">{{@subtitle}}</p>
      {{/if}}

      {{yield}}
      <div class="mt-auto! flex justify-around whitespace-nowrap">
        {{#if @openPreview}}
          <UiButton
            class="mr-2"
            @appearance={{ButtonAppearance.regular}}
            data-test-lesson-preview-link
            {{on "click" @openPreview}}
          >
            {{t "components.tiles.lessonPreviewEntry.preview"}}
          </UiButton>
        {{/if}}
        <LessonResourcesTile @lessonResources={{@lessonResources}} />
      </div>
    </div>
  </ContentTile>
</template>

export default LessonPreviewTile
